<template>
    <v-container class="ma-0 pa-0">
        <v-row class="py-10 px-8">
            <v-row class="ma-0 mb-2">
                <strong>Filtros</strong>
                <v-spacer></v-spacer>
                <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                    <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
                </v-btn>
            </v-row>

            <v-autocomplete @keydown.enter="filter()" v-model="expenses.provider_id" :items="providerLists" item-text="name" item-value="id" attach chips label="Proveedor" multiple>
                <template slot="no-data" class="pa-2">No existen proveedores relacionados.</template>  
            </v-autocomplete>

            <v-menu offset-y :close-on-content-click="closeDatePicker(expenses.date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field  clearable  v-model="expenses.date" label="Fecha" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field><!--fecha programada-->
                </template>
                <v-date-picker v-model="expenses.date" range></v-date-picker>
            </v-menu>
            <v-menu offset-y :close-on-content-click="closeDatePicker(expenses.expiration_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field  clearable  v-model="expenses.expiration_date" label="Fecha de Vencimiento" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field><!--fecha programada-->
                </template>
                <v-date-picker v-model="expenses.expiration_date" range></v-date-picker>
            </v-menu>

            <v-select @keydown.enter="filter()" v-model="expenses.pay" :items="sinoLists" item-text="text" item-value="value" label="Pagado"></v-select>

            <v-text-field @keydown.enter="filter()" v-model="expenses.invoice" label="Factura"></v-text-field>

            <v-autocomplete @keydown.enter="filter()" v-model="expenses.type_id" :items="typeLists" item-text="name" item-value="id" attach chips label="Tipo de Gasto" multiple>
                <template slot="no-data" class="pa-2">No existen tipos de gasto relacionados.</template>  
            </v-autocomplete>

            <v-text-field @keydown.enter="filter()" v-model="expenses.concept" label="Concepto"></v-text-field>

            <v-autocomplete @keydown.enter="filter()" v-model="expenses.serie" :items="serieLists" item-text="name" item-value="id" attach chips label="Serie" multiple>
                <template slot="no-data" class="pa-2">No existen series relacionadas.</template>  
            </v-autocomplete>
            <v-autocomplete @keydown.enter="filter()" v-model="expenses.payment_method_id" :items="paymentLists" item-text="method" item-value="id" attach chips label="Metodo de Pago" multiple>
                <template slot="no-data" class="pa-2">No existen metodos de pago relacionados.</template>  
            </v-autocomplete>

            <v-autocomplete @keydown.enter="filter()" v-model="expenses.user_id" :items="userLists" item-text="name" item-value="id" attach chips label="Creador" multiple>
                <template slot="no-data" class="pa-2">No existen usuarios relacionados.</template>  
            </v-autocomplete>

            <v-text-field @keydown.enter="filter()" v-model="expenses.description" label="Descripción"></v-text-field>

            <v-menu offset-y :close-on-content-click="closeDatePicker(expenses.pay_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field  clearable  v-model="expenses.pay_date" label="Fecha de Pago" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field><!--fecha programada-->
                </template>
                <v-date-picker v-model="expenses.pay_date" range></v-date-picker>
            </v-menu>

        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>
<script>
  export default {
    props:{
        company:String
    },
    data: () => ({
        menuTo:false,
        menuFrom:false,
        menuTo1:false,
        menuFrom1:false,
        menuTo2:false,
        menuFrom2:false,
        expenses:{
            user_id:'',
            description:'',
            type_id:'',
            provider_id:'',
            serie:'',
            payment_method_id:'',
            concept:'',
            date:[],
            expiration_date:[],
            pay_date:[],
        },
    }),
    computed: {
        userLists(){
            return this.$store.state.user.users;
        }, 
        typeLists(){
            return this.$store.state.expense_type.expense_types;
        }, 
        providerLists(){
            return this.$store.state.provider.providers;
        }, 
        serieLists(){
            return ['Serie A', 'Serie B']
        }, 
        paymentLists(){
            return this.$store.state.payment_method.payment_methods;
        }, 
        sinoLists(){
            return [{text:'Si', value:true}, {text:'No', value:'perro'}]
        }
    },
    created () {
    },
    methods: {
        filter(){
            this.$emit("filtersExpense", this.expenses);
        },
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        removeFilter(){
            this.expenses={
                user_id:'',
                description:'',
                type_id:'',
                provider_id:'',
                serie:'',
                payment_method_id:'',
                concept:'',
                date:[],
                expiration_date:[],
                pay_date:[],
            }
            this.filter()
        }
    }
  }
</script>